import { Trophy } from "lucide-react";
import { TableCard } from "./TableCard";
import type { TableSummary } from "@/features/poker/hooks/useTableLobby";

interface TournamentLobbyProps {
  tables: TableSummary[];
  onJoin: (room: string) => void;
  joining?: boolean;
}

export const TournamentLobby = ({ tables, onJoin, joining }: TournamentLobbyProps) => {
  const sngTables = tables.filter((t) => t.gameMode === "tournament");
  const waiting = sngTables.filter((t) => t.phase === "idle");
  const inProgress = sngTables.filter((t) => t.phase !== "idle");

  return (
    <div className="space-y-4">
      {waiting.length > 0 && (
        <div>
          <div className="flex items-center gap-2 mb-2">
            <Trophy className="w-4 h-4 text-yellow-500" />
            <h3 className="text-sm font-semibold text-muted-foreground">
              Waiting for Players
            </h3>
          </div>
          <div className="space-y-2">
            {waiting.map((table) => (
              <TableCard
                key={table.room}
                table={table}
                onJoin={() => onJoin(table.room)}
                joining={joining}
              />
            ))}
          </div>
        </div>
      )}
      {inProgress.length > 0 && (
        <div>
          <div className="flex items-center gap-2 mb-2">
            <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
            <h3 className="text-sm font-semibold text-muted-foreground">
              In Progress
            </h3>
          </div>
          <div className="space-y-2">
            {inProgress.map((table) => (
              <TableCard
                key={table.room}
                table={table}
                onJoin={() => onJoin(table.room)}
                joining={joining}
              />
            ))}
          </div>
        </div>
      )}
      {sngTables.length === 0 && (
        <p className="text-center text-sm text-muted-foreground py-6">
          No tournaments available
        </p>
      )}
    </div>
  );
};
